function findAncestor (el, ancestor) {
  var isClass = (ancestor.indexOf('.') > -1);
  var a =  ancestor.replace(/\./g, "");
  el = el.parentElement;

  if(isClass){
    while (el && !el.classList.contains(a)){
      el = el.parentElement;
    }
  }
  else{
    while (el && el.tagName != a.toUpperCase() ){
      el = el.parentElement;
    }
  }
  return el;
}